import { useState } from 'react';

import loading from '../loading.gif';

const Panel = (props) => {
    return(
        <div className="">
            <div className="text-lg font-semibold">{props.title}</div>
            <div className="p-3 rounded bg-cod-gray-mid relative">
                <div className="text-utrgv-lightgray mb-2">{props.description}</div>
                {Array.isArray(props.children) ?
                    props.children.map((element, i) =>
                        <div className="bg-cod-gray p-3 mt-2" key={i}>{element}</div>)
                :
                    <div className="bg-cod-gray p-3 mt-2">{props.children}</div>}
                {props.loadingText &&
                <div className="flex justify-center items-center bg-cod-gray opacity-80 absolute top-0 left-0 w-full h-full">
                    <div className="flex flex-row">
                        <img alt="Loading..." src={loading} className='w-6'/>
                        <div className="my-auto ml-1">{props.loadingText}</div>
                    </div>
                </div>}
                {props.errorText &&
                <div className="flex flex-row pt-2 pl-1 my-auto text-utrgv-orange">
                    <div className="my-auto ml-1">{props.errorText}</div>
                </div>}
            </div>
        </div>        
    );
};

// clickable field with arbitrary children
const PanelAction = ({onClick, children}) => {
    return (
        <div className="my-auto" onClick={onClick}>{children}</div>
    );
};

// field with static arbitrary children and optional button
const PanelActionButton = ({buttonLabel, onClick, children}) => {
    return (
        <div className="flex flex-row justify-between">
            <div className="my-auto">{children}</div>
            {buttonLabel &&
            <button className="rounded px-4 py-1 my-auto ml-3 border border-white hover:bg-utrgv-blue"
            onClick={onClick}>{buttonLabel}</button>}
        </div>
    );
};

// editable textbox, button (if specified) performs additional action (e.g. reset)
const PanelEdit = ({value, onChange, onBlur, buttonLabel, onClick, errorMsg}) => {
    return (
        <>
            <div className="flex flex-row justify-between">
                <input id="displayName" type="text" value={value} className={`
                appearance-none w-full h-8 rounded px-3 bg-cod-gray-light focus:outline-none
                ${errorMsg && 'border-2 border-utrgv-orange'}`}
                onChange={onChange}
                onBlur={onBlur}
                />
                {buttonLabel &&
                <button className={`rounded px-4 py-1 ml-3 border border-white
                ${errorMsg ? 'border-utrgv-lightgray text-utrgv-lightgray' : 'hover:bg-utrgv-blue'}`}
                disabled={errorMsg}
                onClick={onClick}>{buttonLabel}</button>}
            </div>
            {errorMsg &&
            <div className="pt-2 text-center text-utrgv-orange">{errorMsg}</div>}
        </>
    );
};

// click button to toggle edit/save text
const PanelModalEdit = ({value, onChange, onBlur, buttonLabel, onClick, errorMsg}) => {
    const [edit, setEdit] = useState(false);

    return (
        <>
            <div className="flex flex-row justify-between">
                {edit ?
                <input id="displayName" type="text" value={value} className={`
                appearance-none w-full h-8 rounded px-3 bg-cod-gray-light focus:outline-none
                ${errorMsg && 'border-2 border-utrgv-orange'}`}
                onChange={onChange}
                onBlur={onBlur}
                />
                :
                <div className="my-auto">{value}</div>}
                {buttonLabel &&
                <button className={`rounded px-4 py-1 ml-3 border border-white
                ${errorMsg ? 'border-utrgv-lightgray text-utrgv-lightgray' : 'hover:bg-utrgv-blue'}`}
                disabled={errorMsg}
                onClick={edit ? () => {
                    onClick(() => setEdit(false));
                }
                :
                () => setEdit(true)}>
                {edit ? 'Save' : buttonLabel}</button>}
            </div>
            {errorMsg &&
            <div className="pt-2 text-center text-utrgv-orange">{errorMsg}</div>}
        </>
    );
};

const PanelPref = ({ label, description, checked, onChange }) => {
    return (
        <div className="flex flex-row justify-between">
            <div className="col-span-5">
                <div>{label}</div>
                <div className="text-utrgv-lightgray">{description}</div>
            </div>
            <label className="flex items-center cursor-pointer justify-self-end">
                <div className="relative">
                    <input type="checkbox" className="sr-only" onChange={onChange} checked={!!checked}/>
                    <div className="slide block bg-cod-gray-light w-10 h-6 rounded-full"></div>
                    <div className="dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition"></div>
                </div>
            </label>
        </div>
    );
};

const PanelPrefs = ({ prefs, onChange }) => {
    return (
        <div className="space-y-6">
            {prefs &&
            prefs.map((pref, i) =>
            <PanelPref label={pref.label} description={pref.description} key={i}
                       checked={pref.checked}
                       onChange={(e) => onChange(i, e.target.checked)}/>)}
        </div>
    );
};

export { Panel, PanelAction, PanelActionButton, PanelEdit, PanelModalEdit, PanelPrefs };
export default Panel;
